export default function WhySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="w-full lg:w-2/5">
            <div className="relative">
              <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-xs font-medium text-foreground-600 mb-6">
                Trusted Since 2024
              </span>
              <div className="aspect-[4/5] rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20quality%20control%20inspection%20scene%20with%20clothing%20items%20being%20checked%20on%20clean%20table%2C%20warm%20natural%20lighting%20from%20large%20window%2C%20minimalist%20workspace%20aesthetic%2C%20cream%20and%20beige%20interior%2C%20editorial%20photography%20style%2C%20soft%20organic%20shadows%2C%20modern%20clean%20composition&width=800&height=1000&seq=why-section-img-01&orientation=portrait"
                  alt="OOPBuy Spreadsheet Qualität"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
              Sicher <br />
              Schnell <br />
              Transparent
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-6 max-w-lg">
              OOPBuy Spreadsheet ist Deine vertrauenswürdige Quelle für den besten Spreadsheet-Guide in Deutschland. Wir bieten geprüfte Qualität, schnelle Lieferung und vollständige Transparenz bei jedem einzelnen Produkt.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                'Geprüfte Verkäufer mit QC-Prozess',
                'Schneller Versand nach Deutschland, Österreich & Schweiz',
                'Transparente Bewertungen und Vergleichstabellen',
                'Regelmäßig aktualisierte Spreadsheet-Daten',
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm text-foreground-700">
                  <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-accent-600"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Mehr erfahren
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}